import ScanMapCard from './scanMapCard.container';

export default ScanMapCard;